/*
 * assets/tm-pocket-measure.js
 * Measurement layer for the pocket landing pages (layout/tm-pocket.liquid).
 * Built 2026-09-14, shared scaffolding step, tuffmug-site/knowledge/runs/2026-09-13-pocket-pages/.
 *
 * Job: read this page's utm_content value and push it to Microsoft Clarity as a custom tag,
 * key "tm_lp_entry", so Clarity's dashboard can be filtered/split by landing-page variant.
 * Clarity cannot split by utm_content on its own — this tag is the only way the four pocket
 * pages (and the base pages) become separable in Clarity. Without it the primary prediction
 * for this shift is unreadable (see p10/analyst-findings.md section 6).
 *
 * Hard rules this file follows (builder role card + packet):
 *  - No click handlers on the buy controls or anything else. This file only reads and tags.
 *  - Must never throw, must never block or slow the page, must never be required for the page
 *    to function. A JS-disabled visitor gets a fully working page; this script simply never runs.
 *  - Loaded with `defer` from layout/tm-pocket.liquid, so it always runs after the DOM (and the
 *    data-tm-lp-entry attribute on the page root) exists.
 */
(function () {
  'use strict';

  function getEntryValue() {
    // Source of truth: the server-rendered attribute on the page root, set by
    // snippets/tm-pocket-measure-attrs.liquid via each page template's literal utm_content string.
    try {
      var root = document.querySelector('[data-tm-lp-entry]');
      var fromAttr = root ? root.getAttribute('data-tm-lp-entry') : null;
      if (fromAttr) { return fromAttr; }
    } catch (e) { /* fall through to query string */ }

    // Fallback only: the URL query string, in case the attribute is missing or empty.
    try {
      var params = new URLSearchParams(window.location.search);
      var fromQuery = params.get('utm_content');
      if (fromQuery) { return fromQuery; }
    } catch (e) { /* nothing left to try */ }

    return null;
  }

  function pushClarityTag(value) {
    try {
      window.clarity('set', 'tm_lp_entry', value);
      return true;
    } catch (e) {
      return false;
    }
  }

  function tagWhenClarityReady(value) {
    var attempts = 0;
    var maxAttempts = 10; // brief retry window, then give up quietly
    var intervalMs = 500;

    function attempt() {
      attempts += 1;
      if (typeof window.clarity === 'function') {
        pushClarityTag(value);
        return;
      }
      if (attempts >= maxAttempts) {
        // Clarity never loaded (blocked, failed, or not installed on this preview). Give up
        // quietly — this script must never surface an error to the visitor or the console.
        return;
      }
      window.setTimeout(attempt, intervalMs);
    }

    attempt();
  }

  try {
    var entryValue = getEntryValue();
    if (entryValue) {
      tagWhenClarityReady(entryValue);
    }
  } catch (e) {
    // Never throw. Measurement failing silently is acceptable; breaking the page is not.
  }
})();
